import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { CdkPortal } from '@angular/cdk/portal';
import { Component, HostListener, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'app-config-cards-select-dropdown',
    templateUrl: './config-cards-select-dropdown.component.html',
    styleUrls: ['./config-cards-select-dropdown.component.scss'],
})
export class ConfigCardsSelectDropdownComponent {
    @Input() public reference: HTMLElement;
    @ViewChild(CdkPortal) public contentTemplate: CdkPortal;

    protected overlayRef: OverlayRef;
    public showing = false;

    constructor(protected overlay: Overlay) {}

    public show() {
        this.overlayRef = this.overlay.create(this.getOverlayConfig());
        this.overlayRef.attach(this.contentTemplate);
        this.syncWidth();
        this.overlayRef.backdropClick().subscribe(() => this.hide());
        this.showing = true;
    }

    public hide() {
        this.overlayRef.detach();
        this.showing = false;
    }

    @HostListener('window:resize')
    public onWinResize() {
        this.syncWidth();
    }

    private syncWidth() {
        if (!this.overlayRef) return;

        const refRect = this.reference.getBoundingClientRect();
        this.overlayRef.updateSize({ width: refRect.width });
    }

    protected getOverlayConfig(): OverlayConfig {
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.reference)
            .withPush(false)
            .withPositions([
                {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'top',
                },
            ]);

        return new OverlayConfig({
            positionStrategy,
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            panelClass: 'dropdown-position-class',
        });
    }
}
